module.exports = __webpack_public_path__ + "static/media/itIcon.4c6f8fb8.svg";